import { render } from "./BankManagement.vue?vue&type=template&id=479cc275"
import script from "./BankManagement.vue?vue&type=script&lang=js"
export * from "./BankManagement.vue?vue&type=script&lang=js"

import "./BankManagement.vue?vue&type=style&index=0&id=479cc275&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__